import { useEffect, useState } from 'react';
import { Backdrop, Box, Modal, styled } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CustomBackdrop = styled(Backdrop)(function () {
  return {
    backgroundColor: 'transparent!important'
  };
});

var getContainerStyles = function getContainerStyles(width, height) {
  var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
  if (width) style.width = width;
  if (height) style.height = height;
  return style;
};

var JoveDialogWrapper = function JoveDialogWrapper(props) {
  var children = props.children,
      open = props.open,
      hideMask = props.hideMask,
      close = props.close,
      className = props.className,
      containerWidth = props.containerWidth,
      containerHeight = props.containerHeight;

  var _useState = useState(getContainerStyles(containerWidth, containerHeight)),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setContainerStyle(getContainerStyles(containerWidth, containerHeight));
  }, [containerWidth, containerHeight]);
  /**
   * methods
   */

  var closeAction = function closeAction() {
    close === null || close === void 0 ? void 0 : close();
  };

  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    disableAutoFocus: true // onClose={closeAction}
    ,
    slots: {
      backdrop: hideMask ? CustomBackdrop : Backdrop
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: containerStyle,
      className: clsx('flex max-h-[80%] flex-col overflow-hidden rounded-xl bg-white', className),
      children: children
    })
  });
};

export default JoveDialogWrapper;